import React, { useState, useEffect, useRef } from 'react';
import sorabh from '../../assests/sD.webp';
import Rohan from '../../assests/Rohan gupta.jpg';
import '../../hamcss/mission.css';
import Rahul from '../../assests/Rahulcrop.jpg';
import anil from '../../assests/anilKumarBansal.webp';
import AshaAnil from '../../assests/Asha-Anil.webp';
import uprndra from '../../assests/HS-Upendra.webp';
import dukhbandu from '../../assests/Dukhabandhu.webp';
import rahul from '../../assests/rahul-gupta.webp';
import rohan from '../../assests/Rohan gupta.jpg';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IoClose } from "react-icons/io5";
import m3 from '../../assests/m3.jpg';
import m1 from '../../assests/m1.webp';
import m2 from '../../assests/m2.webp';
import faith from '../../assests/faith.webp';




// import required modules
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const Misson_Visson = () => {


    const [activeTab, setActiveTab] = useState('boardOfDirector');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };



    const [isOpen, setIsOpen] = useState(false);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && event.target.closest('.popup') === null) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);


    return (

        <>

            <section  >

                <div className="main-section-box-container">

                    <div className='inside-mi-vi-box' >
                        <div className='main-mission-text'>
                            <img src={m1} alt="Our Mission" className="image-box-mi" />
                            <div>
                                <h2 style={{ wordSpacing: "2px", letterSpacing: '0.2px' }}>Our Mission</h2>
                                <p style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className='p-text-mission-v'>To provide innovative, responsible, and customer - focused financial solutions that drive growth and build long-term confidence.</p>
                            </div>
                        </div>

                        <div className='main-mission-text'>
                            <img src={m2} alt="Our Vision" className="image-box-mi" />
                            <div>
                                <h2 style={{ wordSpacing: "2px", letterSpacing: '0.2px' }}>Our Vision</h2>
                                <p style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className='p-text-mission-v'>To consistently create sustainable value for all stakeholders.</p>
                            </div>
                        </div>
                    </div>

                    <div className='main-mission-text-2' style={{ backgroundImage: `url(${faith})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>
                        <div className="inside-misi-val">
                            <div style={{ textAlign: 'center' }}>
                                <h2 style={{ wordSpacing: "2px", letterSpacing: '0.2px' }}>Our Values</h2>
                            </div>
                            <br />
                            <ul>
                                <li style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className="p-text-mission-v"><b>Trust </b> We earn and uphold trust through transparency, reliability, and mutual respect with our people, customers, and partners.</li>
                                <li style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className="p-text-mission-v"><b>Integrity </b> We commit to the highest standards of honesty, ethics, and accountability in every action and decision.</li>
                                <li style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className="p-text-mission-v"><b>Discipline </b>  
We demonstrate discipline through strong governance, prudent risk management, and strict compliance with all regulatory and statutory frameworks.</li>
                                <li style={{ wordSpacing: "2px", letterSpacing: '0.2px' }} className="p-text-mission-v"><b>Excellence </b> We strive for excellence in everything we do — continuously learning, improving, innovating, and delivering exceptional outcomes. </li>
                                
                            </ul>
                        </div>
                    </div>


                </div>


            </section>

        </>


    )
}

export default Misson_Visson